import Pill from '@components/V4/Pill';
import { GOAL_STATUS_TYPES } from '@shared/constants';
import { GoalStatusTypes } from '@shared/enums';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
import { useTranslation } from 'apps/agora/src/TranslationContext';

interface ApplicationStatusPillProps {
  status: GoalStatusTypes;
  className?: string;
  useTranslations?: boolean;
}

const getStatusPreset = (status: GoalStatusTypes, t?: (key: string) => string) => {
  const statusColors: Record<GoalStatusTypes, string> = {
    [GoalStatusTypes.ApplicationNotStarted]: 'bg-customRed',
    [GoalStatusTypes.ApplicationInProgress]: 'bg-customGold',
    [GoalStatusTypes.ApplicationSent]: 'bg-customLila',
    [GoalStatusTypes.ApplicationRejected]: 'bg-customGrey',
    [GoalStatusTypes.ApplicationWithdrawn]: 'bg-customGrey',
    [GoalStatusTypes.OfferReceived]: 'bg-customLime',
    [GoalStatusTypes.OfferAccepted]: 'bg-customPrimary',
    [GoalStatusTypes.OfferDeclined]: 'bg-customGrey',
  };

  const statusTexts: Record<GoalStatusTypes, string> = {
    [GoalStatusTypes.ApplicationNotStarted]: t ? t('parent_application_not_started') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.ApplicationInProgress]: t ? t('parent_application_in_progress') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.ApplicationSent]: t ? t('parent_application_sent') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.ApplicationRejected]: t ? t('parent_application_rejected') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.ApplicationWithdrawn]: t ? t('parent_application_withdrawn') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.OfferReceived]: t ? t('parent_offer_received') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.OfferAccepted]: t ? t('parent_offer_accepted') : GOAL_STATUS_TYPES[status],
    [GoalStatusTypes.OfferDeclined]: t ? t('parent_offer_declined') : GOAL_STATUS_TYPES[status],
  };

  return {
    text: statusTexts[status] || 'Unknown Status',
    color: statusColors[status] || 'bg-customGrey',
  };
};

const ApplicationStatusPill = ({ status, className, useTranslations = false }: ApplicationStatusPillProps) => {
  const { t } = useTranslation();
  const { text, color } = getStatusPreset(status, useTranslations ? t : undefined);

  return <Pill isReadOnly size="small" text={text} className={mergeClassNames(color, className)} />;
};

export default ApplicationStatusPill;
